<template>
  <div class="approve-info-box">
    <div class="approve-btns">
      <el-button class="agree-btn" @click="approve(2)">同意</el-button>
      <el-button class="reject-btn" @click="approve(3)">拒绝</el-button>
    </div>
    <div class="approve-data">
      <span>审批意见：</span>
      <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4}" placeholder="请在下方输入内容" v-model="procData">
      </el-input>
    </div>

  </div>
</template>

<script>
export default {
  components: {

  },
  props: {

  },
  data() {
    return {
      procData: ""
    };
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  methods: {
    approve(type) {
      console.log(type,this.procData)
       this.$emit('approve', type,this.procData)
    }
  },
};
</script>

<style  lang="less">
.approve-info-box {
  padding: 20px 40px;
  .approve-btns {
    margin-bottom: 20px;
    text-align: center;
    .el-button {
      font-size: 16px;
      width: 300px;
      color: #fff;
      background: #79cd51;
      border-radius: 10px;
      border: none;
    }
    .reject-btn {
      background: #ff6d60;
      margin-left: 40px;
    }
  }
  .approve-data {
    display: flex;
    span {
      width: 100px;
      font-size: 14px;
      color: #606266;
    }
    .el-textarea{
        // margin-left: 10px;
    }
  }
}
</style>
